import { render, staticRenderFns } from "./uploadAdd.vue?vue&type=template&id=31f8d44b&scoped=true"
import script from "./uploadAdd.vue?vue&type=script&lang=js"
export * from "./uploadAdd.vue?vue&type=script&lang=js"
import style0 from "./uploadAdd.vue?vue&type=style&index=0&id=31f8d44b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8d44b",
  null
  
)

export default component.exports